import React from 'react'
import styled from 'styled-components'
import {icons} from 'utils/enums/icons'
import CellValue from 'components/CellValue'
import environment from 'utils/enums/environment'

const Container = styled.div`
    width: ${props => props.mobile ? '100%' : 'calc(33.33% - 13.33px)'};
    border-top-right-radius: 2px;
    border-top-left-radius: 2px;
    background-color: rgba(160, 183, 190, 0.24);
    margin-right: ${props => props.mobile ? 0 : '20px'};
    margin-bottom: 20px;
    box-sizing: border-box;

    :nth-child(3n) {
        margin-right: 0;
    }
`

const Title = styled.div`
    font-weight: 600;
    margin: 10px 10px 0 10px;
    display: flex;
    overflow: hidden;

    input {
        width: 100%;
    }
`

const Icon = styled.i`
    color: #a0b7be;
    font-size: 24px;
    padding-right: 10px;
`

const Value = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    height: ${props => props.height}px;
    line-height: ${props => props.height}px;
`

class ItemGrid extends React.Component {
    handleBlur = (e) => {
        if (e.target.value) {
            if (e.target.value !== this.props.item.title) {
                this.props.fetchRenameCol(e.target.value, this.props.item.name)
            }
        } else {
            e.target.value = this.props.item.title
        }
    }

    handleFocus = () => {
        this.props.handleFocus(this.props.item.name)
    }

    render() {
        return (
            <Container mobile={this.props.mobile}>
                <Title>
                    <Icon className={icons[this.props.item.type.toLowerCase()]} />
                    <input
                        data-cell={this.props.item.name}
                        defaultValue={this.props.item.title}
                        onBlur={this.handleBlur}
                        readOnly={!this.props.isDesigner || this.props.mobile}
                        onFocus={this.handleFocus}
                    />
                </Title>
                <Value height={global.TABLE_ROW_HEIGHT}>
                    <CellValue
                        config={this.props.item.config}
                        type={this.props.item.type}
                        defaultValue={this.props.item.defaultValue}
                        foreignerEcn={this.props.item.foreignerEcn}
                        lookupType={this.props.item.lookupType}
                        lookupConfig={this.props.item.lookupConfig}
                        linkedRelation={this.props.item.linkedRelation}
                        name={this.props.item.name}
                        handleUpdateValue={this.props.handleUpdateValue}
                        readonly={this.props.item.connection}
                        environment={environment.Record}
						title={this.props.item.title}
						min={this.props.item.min}
						max={this.props.item.max}
                    />
                </Value>
            </Container>
        )
    }
}

export default ItemGrid
